import React from 'react';
import { Plus } from 'lucide-react';

export interface AddColumnButtonProps {
  onClick: () => void;
}

/**
 * Button to add a new column in the table header
 */
export const AddColumnButton: React.FC<AddColumnButtonProps> = ({ onClick }) => {
  return (
    <div className="relative bg-white border-r border-gray-200 flex-shrink-0 w-12 min-w-12 max-w-12">
      <div className="flex items-center justify-center h-full">
        <button
          id="add-column-btn"
          onClick={onClick}
          className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-50 rounded transition-colors"
        >
          <Plus className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

AddColumnButton.displayName = 'AddColumnButton';
